// jQuery
jQuery(function ($) {
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $(".totop");

  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });
});

// JavaScript

// ------------------------------
// header
// ------------------------------
// スクロール後変化させる
window.addEventListener("scroll", function () {
  // ヘッダーを変数の中に格納する
  const header = document.querySelectorAll("#header, .megamenu");
  // 100px→0以上スクロールしたらヘッダーに「scroll-on」クラスをつける
  header.forEach((header) => {
    header.classList.toggle("scroll-on", window.scrollY > 0);
  });
});

// メガメニュー
$(document).ready(function () {
  $(".megahas").on("click", function () {
    // 全てのmegahas要素からactiveを削除
    $(".megahas").removeClass("active");

    // クリックされた要素にactiveを追加
    $(this).addClass("active");

    const megaName = $(this).attr("data-mega"); // クリックされた要素のdata-mega属性値を取得
    const targetMegaMenu = document.getElementById(megaName); // 対応するメガメニューのIDで要素を取得

    // 他のアクティブなメガメニューを閉じる
    if ($(targetMegaMenu).hasClass("active")) {
      $(targetMegaMenu).removeClass("active"); // アクティブなら閉じる
      $(".megahas").removeClass("active");
    } else {
      $(".megamenu.active").removeClass("active"); // 他のメニューを閉じる
      targetMegaMenu.classList.add("active"); // 新しいメガメニューを開く
    }
  });

  // .megamenu .close-btnをクリックしたとき、全てのmegahasのactiveを解除
  $(".megamenu .close-btn").on("click", function () {
    $(".megahas").removeClass("active"); // 全てのmegahas要素からactiveを削除
    $(".megamenu.active").removeClass("active"); // アクティブなメガメニューも閉じる
  });
});

// ------------------------------
// Text animation
// ------------------------------
//ロールオーバー
let splitTarget = document.querySelectorAll(".js-splitText"); //ターゲットとなる要素を全取得
splitTarget.forEach((target) => {
  // target = ターゲット
  if (!target.classList.contains("is-active")) {
    //ターゲットが'is-active'クラスを持っていない場合
    newText = ""; //生成する要素を格納するための変数
    spanText = target.innerHTML; //ターゲットの中身を取得
    spanText.split("").forEach((char) => {
      // char = character 文字
      if (char.trim() !== "") {
        // 空白をスキップ
        newText += "<span>" + char + "</span>"; // 一文字ずつspanタグで囲む
      }
    });
    newTextBefore = "<div class='before'>" + newText + "</div>"; //beforeクラスをつけた要素を生成
    newTextAfter = "<div class='after'>" + newText + "</div>"; //afterクラスをつけた要素を生成
    newText = "<span class='text-wrap'>" + newTextBefore + newTextAfter + "</span>"; //before after両要素を囲む要素生成
    target.innerHTML = newText; //ターゲットに生成した要素を挿入
  }
});

/* ターゲットにホバーした時の動き */
splitTarget.forEach((target) => {
  if (!target.classList.contains("is-active")) {
    //ターゲットが'is-active'クラスを持っていない場合
    let beforeSpan = target.querySelector(".before").querySelectorAll("span"); //beforeの中にあるspanタグを全取得
    let afterSpan = target.querySelector(".after").querySelectorAll("span"); //afterの中にあるspanタグを全取得
    target.addEventListener("mouseenter", () => {
      //ホバーしたとき
      gsap.to(beforeSpan, { y: "-100%", stagger: 0.03, ease: "power2.out" }); //0.03秒おきに各spanタグをy軸上に移動
      gsap.to(afterSpan, { y: "0%", stagger: 0.03, ease: "power2.out" });
    });
    target.addEventListener("mouseleave", () => {
      //ホバーが外れたとき
      gsap.to(beforeSpan, { y: "0%", stagger: 0.03, ease: "power2.out" });
      gsap.to(afterSpan, { y: "100%", stagger: 0.03, ease: "power2.out" });
    });
  }
});

// ------------------------------
// 追従ボタンを×で閉じる
// ------------------------------
$(".chatbot__close").click(function () {
  $(".chatbot").remove();
});

// ------------------------------
// SP 追従メニュー
// ------------------------------
// "use strict";

const menuContents = document.querySelectorAll(".menu-content");
const bgColorsContent = ["#0081CC", "#00A33E", "#E40077", "#0085CD", "#00A4A8", "#0A308F"];
const menu = document.querySelector(".menu");
const menuItems = menu.querySelectorAll(".menu__item");
const menuBorder = menu.querySelector(".menu__border");
let activeItem = menu.querySelector(".active");

function clickItem(item, index) {
  menu.style.removeProperty("--timeOut");

  activeItem = menu.querySelector(".active");
  // if (activeItem == item) return;
  if (activeItem == item) {
    item.classList.remove("active");
    menuContents.forEach((content) => {
      content.classList.remove("is-open");
      content.style.backgroundColor = ""; // 背景色をリセット
  
      gsap.to(content, { y: "100vh", ease: "power2.inOut" });
    });

    menuBorder.style.display = "none";
    return;
  }

  if (activeItem) {
    activeItem.classList.remove("active");
  }

  item.classList.add("active");
  activeItem = item;
  offsetMenuBorder(activeItem, menuBorder);

  // メニュー内容を切り替える
  menuContents.forEach((content) => {
    content.classList.remove("is-open");
    content.style.backgroundColor = ""; // 背景色をリセット

    gsap.to(content, { y: "100vh", ease: "power2.inOut" });
  });

  const targetContent = document.getElementById(item.getAttribute("data-target"));
  targetContent.classList.add("is-open");
  targetContent.style.backgroundColor = bgColorsContent[index]; // 背景色を変更
  // ここまで

  gsap.to(targetContent, { y: 0, ease: "power2.inOut" });
}

function offsetMenuBorder(element, menuBorder) {
  menuBorder.style.display = "block";
  const offsetActiveItem = element.getBoundingClientRect();
  const left = Math.floor(offsetActiveItem.left - menu.offsetLeft - (menuBorder.offsetWidth - offsetActiveItem.width) / 2) + "px";
  menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
}

// offsetMenuBorder(activeItem, menuBorder);

menuItems.forEach((item, index) => {
  item.addEventListener("click", () => {
    clickItem(item, index);
  });
});

// 閉じるボタンの処理
document.querySelectorAll(".menu-content__close").forEach((button) => {
  button.addEventListener("click", () => {
    menuBorder.style.display = "none";
    if (activeItem) {
      activeItem.classList.remove("active");
    }
    gsap.to(button.closest(".menu-content"), {
      y: "100vh",
      ease: "power2.inOut",
      onComplete: () => {
        button.closest(".menu-content").classList.remove("is-open");
      },
    });
  });
});

// ウィンドウリサイズ時の処理
window.addEventListener("resize", () => {
  offsetMenuBorder(activeItem, menuBorder);
  menu.style.setProperty("--timeOut", "none");
});

// ------------------------------
// Tab
// ------------------------------
$(document).ready(function () {
  $(".js-contents > .tab-contents__item:nth-child(1)").addClass("--active");

  $(".js-tab > .tab__item").click(function () {
    // クリックされたタブの親のタブグループを取得
    var $tabGroup = $(this).closest(".tab");
    // クリックされたタブのindex（位置）を取得
    var index = $(this).index();

    // クリックされたタブにactiveクラスを追加し、他のタブからは削除する
    $tabGroup.find(".js-tab > .tab__item").removeClass("--active");
    $(this).addClass("--active");

    // 対応するコンテンツを表示する
    $tabGroup.find(".js-contents > .tab-contents__item").removeClass("--active");
    $tabGroup.find(".js-contents > .tab-contents__item").eq(index).addClass("--active");
  });
});

// チャンネルのタブ切り替え
$(document).ready(function () {
  $(".js-contents > .channel-tab-contents__item:nth-child(1)").addClass("--active");

  $(".js-tab > .channel-tab__item").click(function () {
    var $tabGroupC = $(this).closest(".channel-tab");
    var index = $(this).index();

    $tabGroupC.find(".js-tab > .channel-tab__item").removeClass("--active");
    $(this).addClass("--active");

    $tabGroupC.find(".js-contents > .channel-tab-contents__item").removeClass("--active");
    $tabGroupC.find(".js-contents > .channel-tab-contents__item").eq(index).addClass("--active");
  });
});

// データ属性を使用してタブの連動
$(document).ready(function () {
  $('.tab[data-tab-group]').each(function () {
    // タブのグループ名を取得
    var group = $(this).data('tab-group');

    $(this).find('.tab__item').click(function () {
      // クリックされたタブのインデックスを取得
      var index = $(this).data('tab-index');
      // 同じグループのタブとコンテンツを取得
      var tabs = $('.tab[data-tab-group="' + group + '"]');

      // タブのアクティブ状態をリセット
      tabs.find('.tab__item').removeClass('--active');
      tabs.find('.tab-contents__item').removeClass('--active');

      // 同じグループ内でクリックされたインデックスをアクティブにする
      tabs.each(function () {
        $(this).find('.tab__item').eq(index).addClass('--active');
        $(this).find('.tab-contents__item').eq(index).addClass('--active');
      });
    });
  });
});

// ------------------------------
// Accordion
// ------------------------------
// $(document).ready(function () {
//   // ボタンがクリックされたときの処理(accordion__bodyを押しても閉じる)
//   $(".js-accordion").on("click", function () {
//     // クリックされたボタンの親要素に対して.activeクラスを付ける
//     $(this).closest(".js-accordion").toggleClass("active");
//     // アコーディオンの内容部分をスライドで表示・非表示する
//     $(this).closest(".js-accordion").find(".accordion__body").slideToggle();
//   });
// });

$(document).ready(function () {
  // .accordion__head をクリックしたときの処理(accordion__bodyを押しても閉じない)
  $(".js-accordion .accordion__head").on("click", function () {
    // クリックされたヘッダーの親要素 (.js-accordion) に .active クラスをトグル
    $(this).closest(".js-accordion").toggleClass("active");

    // クリックされたヘッダーの直後の .accordion__body をスライド表示/非表示
    $(this).siblings(".accordion__body").slideToggle();
  });

  // .accordion__body 内のボタンをクリックした場合にも閉じる処理
  $(".js-accordion .accordion__body button").on("click", function () {
    const accordion = $(this).closest(".js-accordion"); // 親の .js-accordion を取得

    // .accordion__body をスライドアップして閉じる
    accordion.find(".accordion__body").slideUp();

    // .active クラスを削除
    accordion.removeClass("active");
  });
});

// ------------------------------
// ScrollHint
// ------------------------------
document.addEventListener("DOMContentLoaded", function () {
  new ScrollHint(".js-scrollable", {
    scrollHintIconAppendClass: "scroll-hint-icon-white",
    i18n: {
      scrollable: "スクロールできます",
    },
  });
});
// 使い方
//<div class="js-scrollable">
//  <table>
//    ~~~
//  </table>
//</div>

$(function () {
  // アコーディオンのヘッダーがクリックされたときの処理
  $('.faq__accordion-head').on('click', function (e) {
    e.stopPropagation(); // イベントの伝播を防止

    // 現在のアコーディオン要素
    const $currentAccordion = $(this).closest('.js-accordion-faq');

    // 現在のアコーディオンの開閉をトグル
    $currentAccordion.toggleClass('active');
    $currentAccordion.find('> .accordion__body').slideToggle();

    // 同じ階層の他のアコーディオンを閉じる
    $currentAccordion.siblings('.js-accordion-faq').removeClass('active');
    $currentAccordion.siblings('.js-accordion-faq').find('> .accordion__body').slideUp();
  });
});

// ------------------------------
// 各種番組表ページ
// ------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // mainタグにprogramクラスがある場合にのみ処理を実行
  if (document.querySelector("main.program")) {
    const thElements = document.querySelectorAll("th");
    thElements.forEach(th => {
      if (th.textContent.trim() === "放送時間") { // テキストが「放送時間」と一致する場合
        th.classList.add("broadcast-time"); // クラスを追加
      }
    });
  }
});

// ------------------------------
// アンカーリンク
// ------------------------------
$(document).ready(function () {
  // リンククリック時のスクロール処理
  $('a[href^="#"]').on('click', function (e) {
    var headerHeight = $('#header').outerHeight() || 0; // 高さを取得（paddingやborder含める）
    var target = $(this.hash);
    if (target.length) {
      var scrollTarget = target.offset().top - headerHeight - 80; // ヘッダー + 余白
      $('html, body').animate({ scrollTop: scrollTarget }, 500);
      e.preventDefault(); // デフォルト動作を止める
    }
  });
});

// 外部リンクや初回読み込み時の補正は window.load で行う（ズレ防止）（例: #id付きURLで直接来た場合）
// $(window).on('load', function () {
//   if (location.hash) {
//     var headerHeight = $('#header').outerHeight() || 0;
//     var target = $(location.hash);
//     if (target.length) {
//       var scrollTarget = target.offset().top - headerHeight - 80;
//       $('html, body').animate({ scrollTop: scrollTarget }, 500);
//     }
//   }
// });
$(window).on('load', function () {
  if (location.hash) {
    setTimeout(function () {
      var target = $(location.hash);
      if (target.length) {
        var windowWidth = $(window).width();

        // SPとPCで補正値を分ける
        var headerHeight = $('#header').outerHeight() || 0;
        var offset = (windowWidth <= 768) ? 80 : 162; // SPは+80px、PCは補正なしまたは微調整

        var scrollTarget = target.offset().top - headerHeight - offset;
        $('html, body').animate({ scrollTop: scrollTarget }, 500); // スクロール実行
      }
    }, 300); // ← ここが重要：描画待ちのために 300ms 程度遅らせる
  }
});